






module.exports =
  props: ['value']
  data: ->
    email_service_options: [
      { value: 'nylas', text: 'Nylas', icon_class: 'nylas-icon' }
      { value: 'sparkpost', text: 'Sparkpost', icon_class: 'sparkpost-icon' }
    ]

  methods:
    emitChange: (value) ->
      @$emit('input', value)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/companies/email_service_dropdown.vue